<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <div class="float-left ml-3 mt-3">
              <strong class="custom-text-hotpick ml-1">Students</strong>
            </div>
            <br />
            <div style="clear: both"></div>
            <div class="mb-2" v-for="item in students"
                  :key="item.Id"
                  :index="item.Id">
              <CCard class="ml-3 mr-3" @click="GoToManage(item.studentId)" >
                <CCardBody>
                  <CRow>
                    <span class="custom-header-profile">
                      <img
                            v-if="item.studentProfilePhoto == ''"
                            src="../../assets/img/icon/icondefault.svg"
                            style="max-width: -webkit-fill-available" />
                          <img
                            v-else
                            width="50px"
                            height="50px"
                            :src="item.studentProfilePhoto"
                            style="border-radius: 50%; border: 5px solid #fff"
                        /></span>
                    <div>
                      <span>
                        <span class="custom-user-title">{{item.studentName}}</span>
                        <label class="custom-label-muted">{{item.gradeName}}</label>
                        <br />
                        <div
                              v-for="sub in item.focusSubject"
                              :key="sub.Id"
                              :index="sub.Id"
                            >
                              <span class="custom-badge-subject p-0">{{ sub.subjectName }}</span>
                            </div>
                      </span>
                      <span>
                        <span
                          style="position: absolute; top: 40px; right: 30px"
                        >
                          <img src="../../assets/img/icon/chevron-right.svg" @click="GoToManage(item.studentId)" />
                        </span>
                        <span class="custom-type-exam">
                          <label class="ml-2">{{item.examShortName}}</label>
                        </span>
                      </span>
                      <div style="clear: both"></div>
                    </div>
                  </CRow>
                </CCardBody>
              </CCard>
            </div>
            <div style="clear: both"></div>
            <div class="text-center ml-3 mr-3 custom-btn-add" @click="GoToRegisterStudent">+ Register Students
            </div>
            <br />

            
            <br /><br />
            <br /><br />
            <br /><br />
            <br /><br />
            <br /><br />
            <br /><br />
            <br /><br />

            <div style="clear: both"></div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">Manage Students</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>

    <div style="clear: both"></div>
  </div>
</template>

import { Hooper, Slide, Navigation as HooperNavigation,Pagination as HooperPagination } from "hooper";

import "hooper/dist/hooper.css";

<script>
export default {
  name: "ManageStudents",
  e1: "#app",
  
  data: function () {
    return {
      user: {},
      studentProfileAuthorize: "",
      childs: [],
      parent: [],
      students: [],
      hooperSettings: {
        infiniteScroll: true,
        centerMode: true,
        autoPlay: true,
        playSpeed: 3500,
        breakpoints: {
          2400: {
            itemsToShow: 5,
          },
          1800: {
            itemsToShow: 4,
          },
          1500: {
            itemsToShow: 3,
          },
          1100: {
            itemsToShow: 2.5,
          },
          0: {
            itemsToShow: 1.5,
          },
        },
      },
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetAuthorizeProfile(this.user.id);
            this.GetListChild(this.user.id);
            this.GetParentDetail(this.user.id);
            this.GetListProfileStudentsByParentId(this.user.id);
          }
        });
    },
    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
    GetListChild() {
      this.$API
        .get(this.$ListChild + "?userID=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
          }
        });
    },
    GetParentDetail() {
      this.$API
        .get(this.$GetParentDetailByUserId + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parent = response.data;
          }
        });
    },
    GetListProfileStudentsByParentId() {
      this.$API
        .get(this.$ListProfileStudentsByParentId + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },
    GoToRegisterStudent()
    {
       this.$router.push("/RegisterStudentParent");
    },
    GoToManage(studentId) {
      this.$router.push("Manage?studentId=" + studentId );
    },
    GoBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: auto;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}
.images {
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}
.img1 {
  background: salmon;
}
.img2 {
  background: lightblue;
}
.img3 {
  background: coral;
}
.img4 {
  background: lightgreen;
}
.img5 {
  background: pink;
}
h2 {
  color: #fff
}
.hooper {
  height: 100vh;
}
.progress {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.65625rem;
  border-radius: 0.25rem;
  background-color: #ebedef;
  height: 5px;
  border-radius: 10px;
}
.custom-btn-add{
font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 150%;

color: #007CEF;
}
</style>